import {BaseTrackingEvent} from '@udemy-v2/event-tracking';

export class UBCTAClicked implements BaseTrackingEvent {
    readonly _type = 'UBCTAClicked';
}

export class CourseCTAClicked implements BaseTrackingEvent {
    readonly _type = 'CourseCTAClicked';
}

export class ContentInnovationCoursePreviewSelected implements BaseTrackingEvent {
    readonly _type = 'ContentInnovationCoursePreviewSelected';
}
